export default "__VITE_ASSET__DKpCV6PX__"